import { render, staticRenderFns } from "./Schemes.vue?vue&type=template&id=2132dce4&scoped=true&"
import script from "./Schemes.vue?vue&type=script&lang=ts&"
export * from "./Schemes.vue?vue&type=script&lang=ts&"
import style0 from "./Schemes.vue?vue&type=style&index=0&id=2132dce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132dce4",
  null
  
)

export default component.exports